// extracted by mini-css-extract-plugin
module.exports = {"organism__faq-section-container":"styles_organism__faq-section-container__9sxla"};